//抽奖PC WAP公用数据
import { ck, $subscriber } from "fire-wind-water";
import ws from "../services/webinar";

export function buildVoteData(data) {
  return Object.assign(
    {
      src: "",
      isShow: false,
      webinarInfo: {},
      randomNum: 10
    },
    data
  );
}

export function buildVoteMethod(otherMethods) {
  return Object.assign(
    {
      getVote(id, type) {
        let self = this;
        let param = {
          globalUserId: ck.cookie("globalUserId"),
          pollId: id,
          tenantId: self.webinarInfo.tenantId,
          __module__: 2,
          __objId__: self.webinarInfo.webinarId
        };
        let cookie = ck.cookie("smarketMember_" + self.webinarInfo.schemaId);
        if (cookie != "" && cookie != null) {
          param.sess = cookie.session;
        }
        var random = Math.ceil(Math.random() * 10) * 1000;
        if (type && type == "shoudong") {
          random = 0;
        }
        setTimeout(function() {
          ws.voteHasParticipation(param).subscribe(data => {
            let param = {
              pollId: id,
              tenantId: self.webinarInfo.tenantId,
              __module__: 2,
              __objId__: self.webinarInfo.webinarId
            };
            /**
             * fix issue 80256 https://zt.smarket.com.cn/biz/bug-view-80256.html
             * Fix duplicate voting
             * Get the configuration first and then judge whether you can vote
             */
            ws.getVote(param).subscribe(res => {
              const isRepeatAnser = res.content.freq === "0";
              if (data.content.hasJoin.toString() == "0" || isRepeatAnser) {
                let addQueryParams =
                  "&tenantId=" +
                  self.webinarInfo.tenantId +
                  "&moduleId=2" +
                  "&objId=" +
                  self.webinarInfo.webinarId +
                  "&withoutwx=1";
                if (res.content.shortUrl[self.type].longUrl.indexOf("#") > -1) {
                  addQueryParams = "&withoutwx=1";
                }
                window.$sk
                  .goto(
                    res.content.shortUrl[self.type].longUrl + addQueryParams,
                    true
                  )
                  .subscribe(data => {
                    console.log("投票 iframe 地址是", data);
                    self.src = data;
                    console.log("新的 投票 iframe 地址是", self.src);
                  });
                self.isShow = true;
              } else {
                let param1 = {
                  globalUserId: ck.cookie("globalUserId"),
                  pollId: id,
                  tenantId: self.webinarInfo.tenantId,
                  __module__: 2,
                  __objId__: self.webinarInfo.webinarId
                };
                ws.getVote(param1).subscribe(res => {
                  let addQueryParams =
                    "&tenantId=" +
                    self.webinarInfo.tenantId +
                    "&moduleId=2" +
                    "&objId=" +
                    self.webinarInfo.webinarId +
                    "&withoutwx=1";
                  if (
                    res.content.shortUrl[self.type].longUrl.indexOf("#") > -1
                  ) {
                    addQueryParams = "&withoutwx=1";
                  }
                  window.$sk
                    .goto(
                      res.content.shortUrl[self.type].longUrl + addQueryParams,
                      true
                    )
                    .subscribe(data => {
                      self.src = data;
                    });
                  self.isShow = true;
                });
              }
            });
          });
        }, random);
      },
      close() {
        this.isShow = false;
      }
    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;

  $subscriber.subscribe("onPublishVote", data => {
    self.getVote(data[0].id);
  });
  $subscriber.subscribe("onVote", data => {
    if (data.length > 0) {
      self.getVote(data[0].id);
    }
  });
  $subscriber.subscribe("onUserOnlineNum", data => {
    self.randomNum = data.questionnaireDelay.time;
  });
  $subscriber.subscribe("webinarInfo", data => {
    self.webinarInfo = data;
  });
  $subscriber.subscribe("onCloseVote", data => {
    self.close();
  });
  $subscriber.subscribe("clickOnVote", data => {
    if (self.webinarInfo.pollId == undefined || self.webinarInfo.pollId == 0) {
      $subscriber.emit("showPopup", { message: "主办方暂时没有设置投票！" });
    } else {
      self.getVote(self.webinarInfo.pollId, "shoudong");
    }
  });
  // $subscriber.subscribe("showQuestion",()=>{
  //   if(self.webinarInfo.questionaryId){
  //     self.self.getVote(self.webinarInfo.questionaryId);
  //   }else{
  //     $subscriber.emit('showPopup',{message:'主办方暂时没有设置问卷！'})
  //   }
  // })
}
